export default "__VITE_ASSET__VqnQNcsX__"